// extracted by mini-css-extract-plugin
module.exports = {"copyright":"style_copyright__3ei8e","one":"style_one__3b4OA"};